import * as React from "react"

export function useMediaQuery(query: string) {
  const subscribe = React.useCallback(
    (callback: () => void) => {
      const result = matchMedia(query)
      result.addEventListener("change", callback)
      return () => { result.removeEventListener("change", callback); }
    },
    [query],
  )

  // useSyncExternalStore reads the live value on the client (getSnapshot) and
  // falls back to false during SSR (getServerSnapshot) — no setState-in-effect,
  // no cascading render, no hydration flash.
  return React.useSyncExternalStore(
    subscribe,
    () => matchMedia(query).matches,
    () => false,
  )
}
